import React, { useEffect, useRef } from 'react'
import styled from 'styled-components'
import { createPortal } from 'react-dom'

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: ${({ theme }) => theme.colors.overlay};
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: ${({ theme }) => theme.zIndex.overlay};
`

const Content = styled.div`
  background: ${({ theme }) => theme.colors.surface};
  border-radius: ${({ theme }) => theme.radii.lg};
  box-shadow: ${({ theme }) => theme.shadow.lg};
  width: ${({ width }) => width || '560px'};
  max-width: ${({ maxWidth }) => maxWidth || '90vw'};
  border: 1px solid ${({ theme }) => theme.colors.border};
  z-index: ${({ theme }) => theme.zIndex.modal};
  display: flex;
  flex-direction: column;
  max-height: 90vh;
  overflow: hidden;
`

const Header = styled.div`
  padding: 14px 16px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
  font-weight: 600;
  flex-shrink: 0;
  border-radius: ${({ theme }) => theme.radii.lg} ${({ theme }) => theme.radii.lg} 0 0;
`

const Body = styled.div`
  padding: 16px;
  overflow-y: auto;
  flex: 1;
`

export function Modal({ open, onClose, title, children, width, maxWidth, ...props }) {
  const mouseDownTarget = useRef(null)

  useEffect(() => {
    if (!open) return
    const handler = (e) => { if (e.key === 'Escape') onClose && onClose() }
    document.addEventListener('keydown', handler)
    return () => document.removeEventListener('keydown', handler)
  }, [open, onClose])

  const handleMouseDown = (e) => {
    // Only track if the mousedown actually happened on the overlay itself
    mouseDownTarget.current = e.target === e.currentTarget
  }

  const handleOverlayClick = (e) => {
    // Only close if both mousedown and click happened on the overlay
    if (mouseDownTarget.current && e.target === e.currentTarget) {
      onClose && onClose()
    }
    mouseDownTarget.current = false
  }

  if (!open) return null
  return createPortal(
    <Overlay onMouseDown={handleMouseDown} onClick={handleOverlayClick}>
      <Content onClick={(e) => e.stopPropagation()} width={width} maxWidth={maxWidth} {...props}>
        {title && <Header>{title}</Header>}
        <Body>{children}</Body>
      </Content>
    </Overlay>,
    document.body
  )
}
